import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 18l8.5-6L6 6v12zm2-8.14L11.03 12 8 14.14V9.86zM16 6h2v12h-2z"
}), 'SkipNextOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SkipNextOutlined.js
// module id = 6264
// module chunks = 2